// The member in a post's likers list, added or removed the moment they tap Like (the API answer only
// confirms it; on an error the caller puts the old list back). Used by the post card and the post popup.
export const memberAsLiker = (userInfo) => ({
  _id: userInfo?._id,
  name: `${userInfo?.first_name || ""} ${userInfo?.last_name || ""}`.trim(),
  profile_image: userInfo?.profile_image,
});

export const withLiker = (likers = [], member) =>
  likers.some((user) => user._id === member._id) ? likers : [member, ...likers];

export const withoutLiker = (likers = [], member) =>
  likers.filter((user) => user._id !== member._id);
